import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function BatteryBank() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 mt-5 bg-light" id="battery-bank">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-dark">🔋 Battery Bank</h2>
          <p className="text-muted">
            Energy storage solution for solar power systems, UPS, telecom towers, and backup power applications ensuring uninterrupted power supply.
          </p>
        </div>

        {/* Ratings */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-primary mb-3">📏 Ratings</h4>
          <ul className="text-muted">
            <li><strong>Capacity:</strong> 100Ah – 200Ah (or customized)</li>
            <li><strong>Voltage:</strong> 12V, 24V, 48V configurations (can be combined for higher voltages)</li>
            <li><strong>Type:</strong> Lead-acid (VRLA/Gel/AGM) or Lithium-ion</li>
          </ul>
        </div>

        {/* IEC Standards */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-info mb-3">📘 IEC Standards</h4>
          <ul className="text-muted">
            <li><strong>IEC 61427</strong> – Secondary batteries for renewable energy applications</li>
            <li><strong>IEC 60896</strong> – Stationary lead-acid batteries</li>
            <li><strong>IEC 62619</strong> – Safety requirements for lithium-ion batteries</li>
          </ul>
        </div>

        {/* Key Features */}
        <div className="mb-5" data-aos="fade-up">
          <h4 className="text-success mb-3">✨ Key Features</h4>
          <ul className="text-muted">
            <li>High cycle life and deep discharge capability</li>
            <li>Maintenance-free (especially VRLA and Lithium types)</li>
            <li>Compact and modular design for easy expansion</li>
            <li>Reliable performance in varied climatic conditions</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default BatteryBank;
